import ZoneGisementsFormController from './zone.gisements.form.controller';

export default {
    template: require('./zone.gisements.form.html'),
    controller: ZoneGisementsFormController
};
